module.exports = __webpack_public_path__ + "static/img/logo-BNG.5441287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/logo-BNG.png
// module id = yZsE
// module chunks = 1